import { useEffect } from 'react'
import Header from './components/Header'
import Hero from './components/Hero'
import Features from './components/Features'
import Services from './components/Services'
import Contact from './components/Contact'
import Footer from './components/Footer'

import domainConfigs from '@/config/domain'
const config = domainConfigs[import.meta.env.VITE_DOMAIN] || domainConfigs.default
//TODO: pegar informacoes certas do tenant
function LandingPageHome() {
  useEffect(() => {
    document.title = config.title || 'Aplicação'
    // Atualiza o favicon
    let link = document.querySelector("link[rel*='icon']") as HTMLLinkElement
    if (!link) {
      link = document.createElement('link') as HTMLLinkElement
      link.type = 'image/svg+xml'
      link.rel = 'icon'
      document.getElementsByTagName('head')[0].appendChild(link)
    }
    link.href = config.icon
  }, [])

  return (
    <div className="min-h-screen bg-white">
      <Header logo={config.icon} />
      <main>
        <Hero />
        <Features />
        <Services />
        <Contact />
      </main>
      <Footer logo={config.icon} />
    </div>
  )
}

export default LandingPageHome
